function initMapMulti() {
	var coordinates = [];

	jQuery('.location-list .location').each(function(){
		var data_arr = [];
		data_arr[0] = jQuery(this).data('lat');
		data_arr[1] = jQuery(this).data('lng');
		data_arr[2] = jQuery(this).data('title');
		data_arr[3] = jQuery(this).data('url');
		data_arr[4] = jQuery(this).data('address');
		data_arr[5] = jQuery(this).data('phone');


		coordinates.push(data_arr);
	});


	var map = new google.maps.Map(document.getElementById('microsite-location-map'));
	var bounds  = new google.maps.LatLngBounds();
	var infowindow = new google.maps.InfoWindow();

	for (var i in coordinates) {
		var arr = [];	
		arr.push(new google.maps.LatLng(
			parseFloat(coordinates[i][0]),
			parseFloat(coordinates[i][1])
		));

		bounds.extend(arr[arr.length - 1])							

		//generate the markers  
		var marker = new google.maps.Marker({
			position: {lat: parseFloat(coordinates[i][0]), lng: parseFloat(coordinates[i][1]) }, 
			map: map,
			animation: google.maps.Animation.DROP,
			icon: "../wp-content/themes/surepress-psr/resources/dist/images/map-pin.png",
			title: coordinates[i][2],
		});	

		//infowindow
		google.maps.event.addListener(marker, 'click', (function(marker, i) {
			return function() {
				infowindow.setContent( '<div id="microsite_location_container_infowindow"><p><a href="'+coordinates[i][3]+'">'+coordinates[i][2]+'</a><br>'+coordinates[i][4]+'<br><a href="tel:'+coordinates[i][5]+'">'+coordinates[i][5]+'</a></p></div>' );
				infowindow.open(map, marker);					
			}
		}) (marker, i));

		if ( coordinates.length > 1 ){ //IF MULTIPLE MARKERS
			map.fitBounds(bounds);
		} else { // IF SINGLE MARKER ONLY
			map.setCenter( {lat: parseFloat(coordinates[i][0]), lng: parseFloat(coordinates[i][1]) } );
			map.setZoom(15);				
		}
	}
}

$(document).ready(function(){
	google.maps.event.addDomListener(window, 'load', initMapMulti);
}); 


// WEBPACK FOOTER //
// ./scripts/map/map-microsite-location.js